import React from 'react';

export const DeviceSetup = () => (
    <div className="device-setup">
        <h3>Individual device setup</h3>
        <p>In order for users to successfully setup their devices please make sure they have:</p>
        <ul>
            <li>
                Signed in to Microsoft Office{' '}
                <a
                    href="https://support.office.com/en-us/f1/topic/video-sign-in-to-office-f374bfd7-a280-4dae-9274-fbe1b3c04593?NS=EXCEL&Version=90"
                    target="_blank"
                    rel="noreferrer"
                >
                    with their subscription account
                </a>
            </li>
            <li>
                Set{' '}
                <a
                    href="https://learn.microsoft.com/en-us/microsoft-365/cloud-storage-partner-program/plus/add-a-place"
                    target="_blank"
                    rel="noreferrer"
                >
                    &quot;Add-a-place&quot; to Egnyte
                </a>
            </li>
        </ul>
        <p>You can also setup and use enablement script to streamline the integration setup on users&apos; devices</p>
        <button
            type="button"
            className="mass-deployment-btn"
            onClick={() => window.open('https://productreleases.egnyte.com/dl/yfsLow0I9e', '_blank')}
        >
            Mass Deployment - Egnyte Co-Edit Configuration
        </button>
    </div>
);
